module.exports = __webpack_public_path__ + "img/word.22669c87.jpeg";